export const CarrierPlaylists = {
  path: '/carrier/playlists',
  load: () => import('./Playlists'),
  protected: true,
};
